import { render } from "./LandSizesEditing.vue?vue&type=template&id=4c2d25d2&ts=true"
import script from "./LandSizesEditing.vue?vue&type=script&lang=ts"
export * from "./LandSizesEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__